import { axiosAuth } from "./axiosApi";
import { API_PATHS } from "./constants";

export const knowledgeDataBases = async () =>
  axiosAuth.get(`${API_PATHS.KNOWLEDGE_BASES}`);
